import utils from "../../../../../../utils";
import React from "react";
import values from "../../../../../../values";
import Cookies from "js-cookie";
import Context from "../../../../../../context";
import TitleLine from "../../../../../../components/TitleLine";

import * as Yup from "yup";

import { useFormik } from "formik";
import { ICreateAndUpdateCompany } from "../../../../../../types/company.interface";
import {
  CustomButton2,
  CustomCheckBox,
  CustomDropdownSearch,
  CustomInput,
  CustomView,
  ImageUploader,
} from "../../../../../../components";
import {
  ICityItem,
  IProvinceItem,
} from "../../../../../../types/common.interface";
import { useQuery } from "react-query";
import api from "../../../../../../api";
import validations from "../../../../../../validations";
import { uploadImage } from "../../../../../../api/method.post/common";
import { useTranslation } from "react-i18next";

const SuperAgent = () => {
  // ** ===========================================================================================================
  // **                                            Value Validation
  // ** -----------------------------------------------------------------------------------------------------------
  const { setShowModal, createFunction, isLoading } = React.useContext(
    Context.CompanyScreen
  );
  const superAgentIdentify = Cookies.get(values.constants.USER.IDENTIFY);
  const [isDriverWallet, setIsDriverWallet] = React.useState<boolean>(false);
  const [selectedCities, setSelectedCities] = React.useState<ICityItem[]>([]);
  // const [selectedFinancialGroup, setSelectedFinancialGroup] =
  //   React.useState<any>(undefined);

  const [selectedProvinces, setSelectedProvinces] = React.useState<
    IProvinceItem[]
  >([]);
  const [selectedProvinceCode, setSelectedProvinceCode] = React.useState<
    string | undefined
  >();
  const [dropDownErrors, setDropDownErrors] = React.useState<any>({
    province: "",
    city: "",
    images: "",
  });

  // const [selectedNationalCardImage, setSelectedNationalCardImage] =
  //   React.useState<string>();
  // const [selectedNationalCardBackImage, setSelectedNationalCardBackImage] =
  //   React.useState<string>();
  // const [selectedCompanyLicense, setSelectedCompanyLicenseImage] =
  //   React.useState<string>();

  const { t } = useTranslation();

  // !! ===========================================================================================================
  // !!                                            Start API Call
  // !! -----------------------------------------------------------------------------------------------------------
  const getAllProvince = useQuery([values.useQueryKeys.getAllProvince], () =>
    api.get.common.getAllProvince()
  );
  const getAllCity = useQuery(
    [values.useQueryKeys.getAllCity, selectedProvinceCode],
    () =>
      api.get.common.getAllCity({
        provinceCode: selectedProvinceCode,
      })
  );
  // const getAllFinancilalGroup = useQuery(
  //   [values.useQueryKeys?.getAllFinancialGroup],
  //   () => api.post.administrator.getAllFinancialGroup({ limit: 10, page: 1 })
  // );

  // ?? ===========================================================================================================
  // ??                                           Use Formik Function
  // ?? -----------------------------------------------------------------------------------------------------------
  const formik = useFormik<ICreateAndUpdateCompany>({
    enableReinitialize: true,
    initialValues: {
      address: "",
      lastName: "",
      firstName: "",
      kartNumber: "",
      phoneNumber: "",
      shabaNumber: "",
      companyName: "",
      nationalCode: "",
      registrationNumber: "",
      nationalId: "",
    },
    validationSchema: Yup.object({
      address: validations.yupValidations.address,
      lastName: validations.yupValidations.lastName,
      firstName: validations.yupValidations.firstName,
      kartNumber: validations.yupValidations.kartNumber,
      phoneNumber: validations.yupValidations.phoneNumber,
      shabaNumber: validations.yupValidations.shabaNumber,
      companyName: validations.yupValidations.firstName,
      nationalCode: validations.yupValidations.nationalCode,
      registrationNumber: validations.yupValidations.registrationNumber,
      nationalId: validations.yupValidations.nationalId,
    }),

    onSubmit: (values: ICreateAndUpdateCompany, { setSubmitting }) => {
      // if (!superAgentIdentify) return utils.errorHandler(5098);
      const selectedProvinceWithDuplicate = selectedProvinces?.map(
        (item) => item?._id as string
      );

      const formValues: ICreateAndUpdateCompany = {
        ...values,
        superAgent: { _id: superAgentIdentify },
        city: selectedCities?.map((item) => item?._id as string),
        province: selectedProvinceWithDuplicate?.filter(
          (item, index) => selectedProvinceWithDuplicate.indexOf(item) === index
        ),
        isDriverWallet,
        // nationalCardFront: selectedNationalCardImage,
        // nationalCardBack: selectedNationalCardBackImage,
        // companyLicence: selectedCompanyLicense,
      };
      if (
        // selectedNationalCardImage &&
        // selectedNationalCardBackImage &&
        // selectedCompanyLicense &&
        selectedProvinces.length !== 0 &&
        selectedCities.length !== 0
      ) {
        Promise.resolve(createFunction(formValues))
          .then(() => {
            setSelectedCities([]);
            setSelectedProvinces([]);
            // setSelectedNationalCardImage("");
            // setSelectedNationalCardBackImage("");
            // setSelectedCompanyLicenseImage("");
            formik.resetForm();
          })
          .catch((e) => setSubmitting(false));
      }
    },
  });
  const submitHandler = () => {
    // validation
    let dropDownErrorsList = {
      province: "",
      city: "",
      images: "",
    };

    if (selectedProvinces.length === 0) {
      dropDownErrorsList = {
        ...dropDownErrorsList,
        province: t("province_is_required"),
        city: t("city_is_required"),
      };
    } else if (selectedCities.length === 0) {
      dropDownErrorsList = {
        ...dropDownErrorsList,
        city: t("city_is_required"),
      };
    }
    // if (
    //   !selectedNationalCardImage ||
    //   !selectedNationalCardBackImage ||
    //   !selectedCompanyLicense
    // ) {
    //   dropDownErrorsList = {
    //     ...dropDownErrorsList,
    //     images: "لطفا مدارک را به صورت کامل بارگذاری کنید",
    //   };
    // }

    setDropDownErrors(dropDownErrorsList);
    formik.submitForm();
  };

  // async function onUploadImage(
  //   imageFile: File,
  //   setImage: (image: any) => void
  // ) {
  //   const imagePromise = await uploadImage!(imageFile);
  //   if (imagePromise?.CODE === 2042) setImage(imagePromise?.result);
  // }

  // ?? ===========================================================================================================
  // ??                                              JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------
  return (
    <CustomView.Container className="create-form-content">
      <TitleLine title={t("companyInfo")} />
      <CustomView.Row className="form-row">
        <CustomView.Column medium={12} className="form-colum dropdown">
          <CustomInput
            name="companyName"
            id="companyName"
            label={t("companyName")}
            value={formik.values.companyName}
            onValueChange={formik.handleChange}
            formikProps={{ onBlur: formik.handleBlur }}
            error={formik.errors.companyName && formik.touched.companyName}
            errorText={formik.errors.companyName}
          />
        </CustomView.Column>
      </CustomView.Row>
      <CustomView.Row className="form-row">
        <CustomView.Column medium={6} className="form-colum dropdown">
          <CustomInput
            name="registrationNumber"
            id="registrationNumber"
            label={t("registrationNumber")}
            value={formik.values.registrationNumber}
            onValueChange={formik.handleChange}
            formikProps={{ onBlur: formik.handleBlur }}
            error={
              formik.errors.registrationNumber &&
              formik.touched.registrationNumber
            }
            errorText={formik.errors.registrationNumber}
            maxLength={16}
          />
        </CustomView.Column>
        <CustomView.Column medium={6} className="form-colum dropdown">
          <CustomInput
            name="nationalId"
            id="nationalId"
            label={t("nationalId")}
            value={formik.values.nationalId}
            onValueChange={formik.handleChange}
            formikProps={{ onBlur: formik.handleBlur }}
            error={formik.errors.nationalId && formik.touched.nationalId}
            errorText={formik.errors.nationalId}
            maxLength={11}
          />
        </CustomView.Column>
      </CustomView.Row>

      <CustomView.Row className="form-row">
        <CustomView.Column medium={6} className="form-colum dropdown">
          <label className="form-label">{t("province")}</label>
          <CustomDropdownSearch
            items={getAllProvince?.data?.result}
            itemName="Name"
            defaultItem={
              getAllProvince?.data?.result?.find(
                (item: IProvinceItem) => item.Code === selectedProvinceCode
              )
              // selectedProvinces[selectedProvinces.length - 1]
            }
            onSelectItem={(event: IProvinceItem) => {
              setSelectedProvinceCode(event?.Code);
              setDropDownErrors({ ...dropDownErrors, province: "" });
            }}
            placeHolder={t("selectProvince")}
            isSearch
          />
          <div className="error">
            {dropDownErrors.province !== "" && dropDownErrors.province}
          </div>
        </CustomView.Column>
        <CustomView.Column medium={6} className="form-colum dropdown">
          <label className="form-label">{t("city")}</label>
          <CustomDropdownSearch
            items={getAllCity?.data?.result}
            itemName="Name"
            defaultItem={undefined}
            onSelectItem={(event: ICityItem) => {
              !selectedCities?.find((item) => item._id === event._id) &&
                setSelectedCities((prev) => [
                  ...prev,
                  { ...event, ProvinceCode: selectedProvinceCode },
                ]);

              !selectedProvinces?.find((item) => item?._id === event?._id) &&
                setSelectedProvinces((prev) => [
                  ...(prev as IProvinceItem[]),
                  getAllProvince?.data?.result?.find(
                    (item: IProvinceItem) => item?.Code === selectedProvinceCode
                  ) as IProvinceItem,
                ]);
              setDropDownErrors({ ...dropDownErrors, city: "" });
            }}
            placeHolder={t("selectCity")}
            isSearch
          />
          <div className="error">
            {dropDownErrors.city !== "" && dropDownErrors.city}
          </div>
        </CustomView.Column>
        <div className="city-items">
          {selectedCities?.map((item) => (
            <span>
              {item?.Name}{" "}
              <i
                onClick={() => {
                  setSelectedCities(
                    selectedCities?.filter(
                      (filterItem) => filterItem._id !== item._id
                    )
                  );
                  const provinceIndex = selectedProvinces.lastIndexOf(
                    item?.ProvinceCode as IProvinceItem
                  );
                  const newSelectedProvinces = selectedProvinces;
                  newSelectedProvinces?.splice(provinceIndex, 1);
                  setSelectedProvinces(newSelectedProvinces);
                }}
                className="fa-solid fa-xmark close-mark"
              ></i>
            </span>
          ))}
        </div>
      </CustomView.Row>

      <CustomView.Row className="form-row">
        <CustomView.Column medium={12} className="form-colum">
          <CustomInput
            name="address"
            id="address"
            label={t("address")}
            value={formik.values.address}
            onValueChange={formik.handleChange}
            formikProps={{ onBlur: formik.handleBlur }}
            error={formik.errors.address && formik.touched.address}
            errorText={formik.errors.address}
          />
        </CustomView.Column>
      </CustomView.Row>
      <TitleLine title={t("companyManagerInfo")} />
      <CustomView.Row className="form-row">
        <CustomView.Column medium={6} className="form-colum">
          <CustomInput
            name="firstName"
            id="firstName"
            label={t("firstName")}
            value={formik.values.firstName}
            onValueChange={formik.handleChange}
            formikProps={{ onBlur: formik.handleBlur }}
            error={formik.errors.firstName && formik.touched.firstName}
            errorText={formik.errors.firstName}
          />
        </CustomView.Column>
        <CustomView.Column medium={6} className="form-colum">
          <CustomInput
            name="lastName"
            id="lastName"
            label={t("lastName")}
            value={formik.values.lastName}
            onValueChange={formik.handleChange}
            formikProps={{ onBlur: formik.handleBlur }}
            error={formik.errors.lastName && formik.touched.lastName}
            errorText={formik.errors.lastName}
          />
        </CustomView.Column>
      </CustomView.Row>
      <CustomView.Row className="form-row">
        <CustomView.Column medium={6} className="form-colum">
          <CustomInput
            name="nationalCode"
            id="nationalCode"
            label={t("nationalCode")}
            value={formik.values.nationalCode}
            onValueChange={formik.handleChange}
            formikProps={{ onBlur: formik.handleBlur }}
            error={formik.errors.nationalCode && formik.touched.nationalCode}
            errorText={formik.errors.nationalCode}
            maxLength={10}
          />
        </CustomView.Column>
        <CustomView.Column medium={6} className="form-colum">
          <CustomInput
            name="phoneNumber"
            id="phoneNumber"
            label={t("phoneNumber")}
            value={formik.values.phoneNumber}
            onValueChange={formik.handleChange}
            formikProps={{ onBlur: formik.handleBlur }}
            error={formik.errors.phoneNumber && formik.touched.phoneNumber}
            errorText={formik.errors.phoneNumber}
            maxLength={11}
          />
        </CustomView.Column>
      </CustomView.Row>
      <TitleLine title={t("financialInfo")} />
      <CustomView.Row className="form-row">
        {/* <CustomView.Column medium={6} className="form-colum dropdown">
          <label className="form-label">گروه مالی</label>
          <CustomDropdownSearch
            items={getAllFinancilalGroup?.data?.result}
            itemName="name"
            defaultItem={selectedFinancialGroup}
            onSelectItem={(event: any) => {
              setSelectedFinancialGroup(event);
            }}
            placeHolder="انتخاب گروه مالی"
          />
        </CustomView.Column> */}
        <CustomView.Column medium={6} className="form-colum">
          <CustomInput
            name="shabaNumber"
            id="shabaNumber"
            label={t("shabaNumber")}
            value={formik.values.shabaNumber}
            onValueChange={formik.handleChange}
            formikProps={{ onBlur: formik.handleBlur }}
            error={formik.errors.shabaNumber && formik.touched.shabaNumber}
            errorText={formik.errors.shabaNumber}
            maxLength={24}
            isShaba
          />
        </CustomView.Column>
        <CustomView.Column medium={6} className="form-colum">
          <CustomInput
            name="kartNumber"
            id="kartNumber"
            label={t("cardNumber")}
            value={formik.values.kartNumber}
            onValueChange={formik.handleChange}
            formikProps={{ onBlur: formik.handleBlur }}
            error={formik.errors.kartNumber && formik.touched.kartNumber}
            errorText={formik.errors.kartNumber}
            maxLength={16}
          />
        </CustomView.Column>
        <CustomView.Column medium={6} className="form-colum">
          <CustomCheckBox
            isChecked={isDriverWallet}
            onChecked={() => setIsDriverWallet((prev) => !prev)}
            label={t("pay_driver_money_to_company")}
          />
        </CustomView.Column>
      </CustomView.Row>

      {/* <TitleLine title="مدارک شرکت" />
      <CustomView.Row className="form-row dropdown">
        {dropDownErrors.images !== "" && (
          <div
            className="dropdown"
            style={{ minHeight: "0.7rem", color: "red", fontSize: "0.7rem" }}
          >
            <div className="">{dropDownErrors.images}</div>
          </div>
        )}
        <CustomView.Column medium={4} className="">
          <ImageUploader
            defaultImage={selectedNationalCardImage}
            setImage={setSelectedNationalCardImage}
            uploadImage={(event: any) =>
              onUploadImage(event, setSelectedNationalCardImage)
            }
            label="کارت ملی مدیر شرکت"
          />
        </CustomView.Column>{" "}
        <CustomView.Column medium={4} className="">
          <ImageUploader
            defaultImage={selectedNationalCardBackImage}
            setImage={setSelectedNationalCardBackImage}
            uploadImage={(event: any) =>
              onUploadImage(event, setSelectedNationalCardBackImage)
            }
            label="پشت کارت ملی مدیر شرکت"
          />
        </CustomView.Column>{" "}
        <CustomView.Column medium={4} className="">
          <ImageUploader
            defaultImage={selectedCompanyLicense}
            setImage={setSelectedCompanyLicenseImage}
            uploadImage={(event: any) =>
              onUploadImage(event, setSelectedCompanyLicenseImage)
            }
            label="جواز شرکت"
          />
        </CustomView.Column>{" "}
      </CustomView.Row> */}

      <CustomView.Row className="form-row buttons-group">
        <CustomView.Column
          large={3}
          medium={4}
          small={6}
          className="form-colum"
        >
          <CustomButton2
            isLoading={isLoading}
            onClick={() => setShowModal("NONE")}
            title={t("cancel")}
            type="danger"
          />
        </CustomView.Column>
        <CustomView.Column
          large={3}
          medium={4}
          small={6}
          className="form-colum"
        >
          <CustomButton2
            isLoading={isLoading}
            onClick={submitHandler}
            title={t("submit")}
          />
        </CustomView.Column>
      </CustomView.Row>
    </CustomView.Container>
  );
};

export default SuperAgent;
